import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInMonths,
  differenceInSeconds,
  differenceInYears,
} from 'date-fns';

/** Compact relative labels for activity feeds (e.g. "1h", "10d", "3mo"). */
export function formatActivityRelativeTime(input) {
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return '';

  const now = new Date();
  if (date > now) return 'now';

  const sec = differenceInSeconds(now, date);
  if (sec < 45) return 'now';

  const min = differenceInMinutes(now, date);
  if (min < 60) return `${min}m`;

  const hrs = differenceInHours(now, date);
  if (hrs < 24) return `${hrs}h`;

  const days = differenceInDays(now, date);
  if (days < 31) return `${days}d`;

  const months = differenceInMonths(now, date);
  if (months >= 1 && months < 12) return `${months}mo`;

  const years = differenceInYears(now, date);
  if (years >= 1) return `${years}y`;

  return `${days}d`;
}
